import Vue from 'vue';

const success = (response, context) => {
  context.loading = false;
  if (context.isContractPhoneNumberValid) {
    context.isValidated = true;
    !context.contract.id ? context.createBookingContract(context.contract) : context.updateBookingContract(context.contract);
  } else {
    context.isValidated = false;
  }
};

const failed = (error, context) => {
  context.loading = false;
  context.showToasterError(error);
};

export default (contract, context) => {
  return Vue.$http.post('bookings/contract/validate-for-update', contract)
    .then((response) => {
      if (response && response.status === 200) {
        success(response, context);
      }
    })
    .catch((error) => {
      failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/booking/validateBookingContractForUpdate.js